"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageHeader = void 0;
var _mui = require("@ori-ui/mui");
var _react = _interopRequireDefault(require("react"));
var _ErrorIcon = require("../ErrorIcon");
var _jsxRuntime = require("react/jsx-runtime");
const PageHeader = ({
  errorCode,
  headerText
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Box, {
    sx: {
      justifyContent: 'center'
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ErrorIcon.ErrorIcon, {
      errorCode: errorCode
    })
  }), headerText ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
    role: "heading",
    "arial-level": "3",
    variant: "h3",
    children: headerText
  }) : null]
});
exports.PageHeader = PageHeader;
